// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3522":"css/mail","6150":"website/css/app","8252":"css/app"}[chunkId] + ".css";
};